export default [
  {
    title: `Start Impressing Prospects Today`,
    description: `Easily create stunning and customized proposals that make you stand out.`,
    icon: 'customization'
  },
  {
    title: `Inspire Prospects to Choose You`,
    description: `Stun prospects with a detailed portrait of their site by importing your Walkthrough.`,
    icon: 'importWalkthrough'
  },
  {
    title: `Close the Deal`,
    description: `Edit, save, and convert proposals quickly to PDF's for easy sharing.`,
    icon: 'convertToPDF'
  }
]
